import styled from 'styled-components';

export const Container = styled.div`
  max-width: 750px;
  padding: 10px 2%;
  margin: 2% auto;
  font-size: 16px;
`;
